export default __webpack_public_path__ + "static/media/convert-wallet.80a5fab7.png";